module.exports = __webpack_public_path__ + "img/انتزاعی.5bb6f390.png";